import PropTypes from "prop-types"

import CreatSomethingSpecial from "areas/info/create-something-special"

import InfoLayout from "./info-layout"
import InfoLayoutNew from "./info-layout-new"
import InfoLayoutRebrand from "./info-layout-rebrand"
import NoInfoLayout from "./no-info-layout"

const InfoRouteWrapper = ({
  children,
  hidePageTitle,
  isNewDesign,
  layout,
  newLayout,
  rebrand,
  removeLayout,
  showCta,
  title,
}) => (
  <>
    {newLayout ? (
      <InfoLayoutNew {...{ hidePageTitle, isNewDesign, layout, title }}>
        {children}
      </InfoLayoutNew>
    ) : rebrand ? (
      <InfoLayoutRebrand {...{ title }}>{children}</InfoLayoutRebrand>
    ) : removeLayout ? (
      <NoInfoLayout {...{ layout, title }}>{children}</NoInfoLayout>
    ) : (
      <InfoLayout {...{ layout, title }}>{children}</InfoLayout>
    )}
    {showCta && <CreatSomethingSpecial />}
  </>
)

InfoRouteWrapper.propTypes = {
  children: PropTypes.node,
  hidePageTitle: PropTypes.bool,
  isNewDesign: PropTypes.bool,
  layout: PropTypes.string,
  newLayout: PropTypes.bool,
  rebrand: PropTypes.bool,
  removeLayout: PropTypes.bool,
  showCta: PropTypes.bool,
  title: PropTypes.string,
}

export default InfoRouteWrapper
